import {
	currentPeriodType,
	getPeriodTypeFromId,
} from "../../period/PeriodType.js";
import {
	getFormattedValue,
	nameAndValueLabel,
	nameLabel,
	valueLabel,
} from "./helpers.js";
import KeyFigureFormulaToken from "../../keyFigure/formulaToken/KeyFigureFormulaToken.js";

const defaultPeriodType = currentPeriodType;

/**
 * Todo: Add JSDoc comment
 */
export default function getKeyFigureValueSpec({
	makeKeyFigurePopover,
	keyFigureCalculationService,
	getPeriod,
	getPeriodReportValuesKeyFigurePreset,
	isBimesterEnabled,
	isEditor,
}) {
	return {
		type: "keyfigure",
		attributes: ["id"],
		optionalAttributes: {
			shift: 0,
			shiftPeriodType: defaultPeriodType.getId(),
			periodType: defaultPeriodType.getId(),
			precision: "default",
			display: valueLabel,
		},
		makePopover: setupPopover({
			makeKeyFigurePopover,
			getPeriod,
			isBimesterEnabled,
			isEditor,
		}),
		getValue,
		getTitle: ({ keyFigure }) => keyFigure.getName(),
		fetcher: async ({
			id,
			shift: shiftAsString,
			shiftPeriodType: shiftPeriodTypeId,
			periodType: periodTypeId,
			precision,
			display,
		}) => {
			const shift = +shiftAsString;
			const shiftPeriodType = getPeriodTypeFromId(shiftPeriodTypeId);
			const periodType = getPeriodTypeFromId(periodTypeId);
			const preset = await getPeriodReportValuesKeyFigurePreset();
			const keyFigure = preset.getKeyFigureById(id);
			keyFigure.setPrecision(precision);

			const data = {
				name: keyFigure.getName(),
				keyFigure,
				precision,
				shift,
				shiftPeriodType,
				periodType,
				display,
			};

			if (display === nameLabel) {
				return data;
			}

			const result =
				await keyFigureCalculationService.fetchKeyFigureResult({
					periods: [getPeriod()],
					keyFigure: makeShiftedKeyFigure({
						keyFigure,
						shift,
						shiftPeriodType,
						periodType,
					}),
				});

			data.value = result.getValues()[0];

			return data;
		},
	};
}

/**
 * Get the value for the KPI input value.
 *
 * Since the display value is `valueLabel` by default, this code should reflect
 * it for backward-compatibility reasons.
 */
function getValue({ name, value, display, precision }) {
	if (display === nameLabel) {
		return name.toString();
	}

	const formattedValue = getFormattedValue({ value, precision });

	if (display === nameAndValueLabel) {
		return `${name}: ${formattedValue}`;
	}

	return formattedValue;
}

/**
 * Todo: Add JSDoc comment
 */
export function makeShiftedKeyFigure({
	keyFigure,
	shift,
	shiftPeriodType,
	periodType,
}) {
	const formulaToken = new KeyFigureFormulaToken({
		keyFigure,
		shift,
		shiftPeriodType,
		periodType,
	});

	const clone = keyFigure.clone();
	clone.setFormula(formulaToken.asFormulaNode());

	return clone;
}

function setupPopover({
	makeKeyFigurePopover,
	getPeriod,
	isBimesterEnabled,
	isEditor,
}) {
	if (!makeKeyFigurePopover) {
		return undefined;
	}

	return ({ updateNodeAttributes, getTriggerItem, content }) =>
		makeKeyFigurePopover({
			isEditor,
			getPeriod,
			isBimesterEnabled,
			defaultPeriodType,
			updateNodeAttributes,
			getTriggerItem,
			content,
		});
}
